import { useState } from "react";
import { E, useEditableContent } from "@/components/EditableText";
import { TEAM } from "@/lib/teamData";

const SUN = "#F5B400";
const SUN_DEEP = "#C98F00";
const INK = "#0F1E2E";

function Bio({ i, text }) {
  const { editMode } = useEditableContent();
  const [expanded, setExpanded] = useState(false);
  const clamp = !editMode && !expanded;
  return (
    <div className="text-sm opacity-80 leading-relaxed">
      <p style={clamp ? { display: "-webkit-box", WebkitLineClamp: 5, WebkitBoxOrient: "vertical", overflow: "hidden" } : undefined}>
        <E k={`team.m${i + 1}.bio`} defaultText={text} as="span" multiline />
      </p>
      {!editMode && (
        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          className="pcp-mono text-[10px] mt-2 inline-flex items-center gap-1 hover:opacity-100 opacity-65 transition"
          style={{ color: SUN_DEEP, letterSpacing: "0.18em" }}
          data-testid={`team-bio-toggle-${i}`}
        >
          {expanded ? "Read less ↑" : "Read more ↓"}
        </button>
      )}
    </div>
  );
}

export function TeamSection() {
  return (
    <section id="team" className="px-6 md:px-12 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <p className="pcp-mono text-[11px] mb-4" style={{ color: SUN_DEEP }}>/ Meet the team</p>
        <h2 className="pcp-h text-4xl md:text-5xl mb-6 max-w-4xl">
          <E k="team.headline" defaultText="Real compliance professionals. Not engineers learning compliance on your dime." as="span" multiline />
        </h2>
        <p className="text-base md:text-lg opacity-80 max-w-3xl mb-10 leading-relaxed">
          <E
            k="team.intro"
            defaultText="The people who'll actually work with your company, plus the founder behind the system. Pick the ones you want on your engagement — the calculator above lets you build your team by the hour."
            as="span"
            multiline
          />
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 items-start">
          {TEAM.map((m, i) => (
            <div key={m.name} className="pcp-card p-5">
              <div className="flex items-start gap-3 mb-3">
                <div className="flex-shrink-0 overflow-hidden rounded-full border-2" style={{ height: 56, width: 56, borderColor: `${SUN}55`, background: "rgba(15,30,46,0.04)" }}>
                  <img
                    src={m.photo}
                    alt={m.name}
                    className="w-full h-full"
                    style={{ objectFit: "cover", objectPosition: "center 20%" }}
                    loading="lazy"
                    data-testid={`team-photo-${i}`}
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold leading-tight" style={{ color: INK }}>
                    <E k={`team.m${i + 1}.name`} defaultText={m.name} as="span" />
                  </div>
                  <div className="pcp-mono text-[9px] mt-1" style={{ color: SUN_DEEP, letterSpacing: "0.14em" }}>
                    <E k={`team.m${i + 1}.role`} defaultText={m.role} as="span" />
                  </div>
                </div>
              </div>
              <Bio i={i} text={m.bio} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
